import { render, staticRenderFns } from "./CurriculumFilter.vue?vue&type=template&id=18de50bb&"
import script from "./CurriculumFilter.vue?vue&type=script&lang=js&"
export * from "./CurriculumFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports